import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TFocusFieldState = {
  focusFieldId: string | null;
};

export type TActionButtonsState = {
  buttonId: string;
  prpName: string;
  prpValue: boolean;
};

export type TStepperStep = {
  stepNumber: number | null;
  stepTitle: string | null;
};
export interface IJSApiSlice {
  stepChange: TStepperStep[];
  fieldFocusTo: {
    focusFieldId: string | null;
  };
  gridActions: {
    apiAction: 'refresh' | null;
    apiGridId: string | null;
    apiGridRowIndex?: string | null;
  };
  fileInputUpdateProps: {
    apiFieldId: string | null;
    apiAction: string | null;
    apiFieldProp: string | null;
  };
  actionButtonsState: {
    buttonId: string | null;
    prpName: string;
    prpValue: boolean;
  };
}

const JSApiSlice = createSlice({
  name: 'JSApiSlice',
  initialState: {
    stepChange: [],
    fieldFocusTo: { focusFieldId: null },
    gridActions: { apiAction: null, apiGridId: null, apiGridRowIndex: null },
    fileInputUpdateProps: {
      apiFieldId: null,
      apiAction: null,
      apiFieldProp: null,
    },
    actionButtonsState: { buttonId: null, prpName: '', prpValue: false },
  } as IJSApiSlice,
  reducers: {
    setFieldFocusFromJSApi: (
      state,
      action: PayloadAction<TFocusFieldState>,
    ) => {
      state.fieldFocusTo = action.payload;
    },
    setStepperFromJSApi: (state, action: PayloadAction<TStepperStep>) => {
      state.stepChange.push(action.payload);
    },
    setGrid: (state, action: PayloadAction<IJSApiSlice['gridActions']>) => {
      state.gridActions = action.payload;
    },
    setFileInputFromJSApi: (
      state,
      action: PayloadAction<IJSApiSlice['fileInputUpdateProps']>,
    ) => {
      state.fileInputUpdateProps = action.payload;
    },
    setActionButtonsPropsFromJSApi: (
      state,
      action: PayloadAction<TActionButtonsState>,
    ) => {
      state.actionButtonsState = action.payload;
    },
  },
});

export default JSApiSlice.reducer;
export const {
  setStepperFromJSApi,
  setFieldFocusFromJSApi,
  setGrid,
  setActionButtonsPropsFromJSApi,
  setFileInputFromJSApi,
} = JSApiSlice.actions;
